/* eslint-disable max-len */
/* eslint-disable no-console */
import {Modal, Image, Progress, Form, Button, Input} from 'antd';
import axios from 'axios';
import React, {useState, useEffect, useRef} from 'react';

import {yearKeyLabel} from '../../../components/Forms/Constants/IP/commonKeyLabel';
import {EmpKey} from '../../../components/Forms/Constants/IP/EmpKeyLabel';
import Loader from '../../../components/Loader/Loader';
import {drawerZIndex} from '../../../constants/Common';
import {APITypeEnum} from '../../../services/interface/tableAPIType';
import OPCategory from '../../../services/modules/JSON/categoryOP';
import cityJSON from '../../../services/modules/JSON/cityJSON';
import country from '../../../services/modules/JSON/country';
import statesJSON from '../../../services/modules/JSON/statesJSON';
import OPSubCategory from '../../../services/modules/JSON/subCategory';
import typeOfBusiness from '../../../services/modules/JSON/typeOfBusiness';
import activeFacilityCount from '../../../services/modules/OM/activeFacilityCount';
import companyDetails from '../../../services/modules/OM/companyDetails';
import facilityDetailsFetch from '../../../services/modules/OM/facilityDetailsFetch';
import getSustainabilityResponses from '../../../services/modules/OM/sustainabilityResponses';
import userSetup from '../../../services/modules/User/userSetup';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';
import {yearSelect} from '../../../utils/FormUtils/yearSelect';
import {OPKey} from '../../configurator/orgFacility/orgInfo/constants/orgProfileKeyLabel';
import {filterCompanyDetails} from '../../configurator/orgFacility/orgInfo/utils/commonFunctions';

import SetupAwesome from './../../../assets/SetupAwesome.png';
import SetupBuisness from './../../../assets/SetupBuisness.png';
import SetupSustainabiltyView1 from './../../../assets/SetupSustainabiltyView1.png';
import SetupSustainabiltyView2 from './../../../assets/SetupSustainabiltyView2.png';
import SetupSustainabiltyView3 from './../../../assets/SetupSustainabiltyView3.png';
import SetupSustainabiltyView4 from './../../../assets/SetupSustainabiltyView4.png';
import welcomeScreen from './../../../assets/welcomeScreen.png';
import {userSignUpValidationMessages} from './Constants/userSignUpValidationMessages';
import CompanyDetailForm from './GuestCompanySetUpWizard/CompanyDetailForm';
import FacilityHeadquarterForm from './GuestCompanySetUpWizard/FacilityHeadquarterForm';
import FinalDetail from './GuestCompanySetUpWizard/FinalDetail';
import SustainabilityDetailForm from './GuestCompanySetUpWizard/SustainabilityDetailForm';
import WelcomeForm from './GuestCompanySetUpWizard/WelcomeForm';

interface GuestCompanySetUpWizardProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  allDone: React.Dispatch<React.SetStateAction<boolean>>;
}

const GuestCompanySetUpWizard: React.FC<GuestCompanySetUpWizardProps> = ({
  visible,
  setVisible,
  allDone
}) => {
  const companyData = useCompanyStore((state) => state.companyDetails);
  const {refUserId, _id} = useUserStore.getState().userDetails;
  const [currentStep, setCurrentStep] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const companyId = useCompanyStore.getState().companyId;
  const targetRef = useRef<HTMLDivElement>(null);
  const [pendingValidationError, setPendingValidationError] = useState<{
    name: any[];
    message: string;
  } | null>(null);
  const [form] = Form.useForm();
  const formInitialValues = {
    employeeId: refUserId,
    userId: _id,
    company: {...companyData},
    facilities: {company: companyId, year: ''},
    sustanability: {},
    employee: {}
  };

  const enum wizardIds {
    WELCOME = 'WELCOME',
    BUSINESS = 'BUSINESS',
    FACILITY = 'FACILITY',
    SUSTAINABILITY = 'SUSTAINABILITY',
    FINAL = 'FINAL',
    AWESOME = 'AWESOME'
  }

  useEffect(() => {
    form.setFieldsValue({
      employeeId: refUserId,
      userId: _id,
      facilities: {company: companyId}
    });
  }, [refUserId, _id, companyId]);

  useEffect(() => {
    const year = yearSelect(form.getFieldValue('company.fiscalYear'))?.[0]
      ?.value;

    Promise.all([
      year &&
        facilityDetailsFetch(
          APITypeEnum.GET_ALL,
          undefined,
          `${companyId}/${year}`
        ),
      getSustainabilityResponses(),
      OPCategory(),
      OPSubCategory(),
      typeOfBusiness(),
      companyDetails(),
      country(),
      statesJSON(),
      cityJSON(),
      false
    ])
      .then(([res1, res2]) => {
        if (companyData?.fiscalYear && companyData?.subCategory > 0) {
          setCurrentStep(1);
        }

        if (year && res1 && res1.length > 0) {
          form.setFieldsValue({
            facilities: {...res1[0]}
          });
        }
        if (res2) {
          form.setFieldsValue({
            sustanability: {...res2}
          });
        }
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (pendingValidationError) {
      form.setFields([
        {
          name: pendingValidationError.name,
          errors: [pendingValidationError.message]
        }
      ]);
      setPendingValidationError(null); // reset
    }
  }, [currentStep]);

  const steps = [
    {
      id: wizardIds.WELCOME,
      title: '',
      image: welcomeScreen,
      component: <WelcomeForm welcomePage={goNext} />
    },
    {
      id: wizardIds.BUSINESS,
      title: 'Business Details',
      image: SetupBuisness,
      component: <CompanyDetailForm />
    },
    {
      id: wizardIds.FACILITY,
      title: 'Headquarter Details',
      image: SetupBuisness,
      component: (
        <FacilityHeadquarterForm
          data={{...form.getFieldsValue(true)}}
          setSelectedCountry={() => {}}
        />
      )
    },
    {
      id: wizardIds.SUSTAINABILITY,
      title: 'Sustainability Views',
      image: SetupSustainabiltyView1,
      component: <SustainabilityDetailForm index={0} />
    },
    {
      id: wizardIds.SUSTAINABILITY,
      title: 'Sustainability Views',
      image: SetupSustainabiltyView2,
      component: <SustainabilityDetailForm index={1} />
    },
    {
      id: wizardIds.SUSTAINABILITY,
      title: 'Sustainability Views',
      image: SetupSustainabiltyView3,
      component: <SustainabilityDetailForm index={2} />
    },
    {
      id: wizardIds.FINAL,
      title: 'Sustainability Views',
      image: SetupSustainabiltyView4,
      component: <SustainabilityDetailForm index={3} />
    },
    {
      id: wizardIds.AWESOME,
      title: 'Awesome',
      image: SetupAwesome,
      description: '',
      component: (
        <FinalDetail
          finalPage={() => {
            setVisible(false);
            setCurrentStep(0);
            allDone(true);
          }}
        />
      )
    }
  ];

  const isLast = steps.length - 1;

  function goNext() {
    if (targetRef.current) {
      const top = 0;
      targetRef.current.scrollTo({top, behavior: 'smooth'});
    }
    form
      .validateFields()
      .then(() => {
        setCurrentStep(currentStep + 1);
      })
      .catch((errorInfo) => {
        if (errorInfo.errorFields && errorInfo.errorFields.length > 0) {
          form.scrollToField(errorInfo.errorFields[0].name);
        }
      });
  }

  function goBack() {
    setCurrentStep((prev) => Math.max(prev - 1, 0));
  }

  const onSubmit = () => {
    const values = {...form.getFieldsValue(true)};
    const {...restValues} = values.company;
    const cdata = filterCompanyDetails({...companyData, ...restValues});
    const inputData = values;
    inputData.company = cdata;
    setIsSubmitted(true);
    Promise.all([
      userSetup({
        ...inputData
      })
    ])
      .then(async () => {
        await Promise.all([
          (steps[currentStep].id === wizardIds.BUSINESS ||
            steps[currentStep].id === wizardIds.FINAL) &&
            companyDetails(undefined, true),
          steps[currentStep].id === wizardIds.FACILITY && activeFacilityCount()
        ]);

        if (steps[currentStep].id === wizardIds.FACILITY) {
          useCompanyStore.getState().setTriggerFacilityRefresh(true);
        }
      })
      .then(() => {
        goNext();
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          if (error.response) {
            const {status, message} = error.response.data;
            duplcateValueValidation(status, message);
          } else {
            console.error('No response received:', error.request);
          }
        } else {
          console.error('Unexpected error:', error);
        }
      })
      .finally(() => {
        setIsSubmitted(false);
      });
  };

  const duplcateValueValidation = (status: string, message: string) => {
    switch (status) {
      case userSignUpValidationMessages.DUPLICATE_BUSINESS_EMAIL:
        setPendingValidationError({
          name: ['company', OPKey.PERSONAL_EMAIL],
          message
        });
        setCurrentStep(0);
        break;
      case userSignUpValidationMessages.DUPLICATE_GSTNO:
        setPendingValidationError({name: ['company', OPKey.TAX], message});
        setCurrentStep(0);
        break;
      case userSignUpValidationMessages.DUPLICATE_PAN:
        setPendingValidationError({name: ['company', OPKey.IDENTITY], message});
        setCurrentStep(0);
        break;
      case userSignUpValidationMessages.DUPLICATE_CIN:
        setPendingValidationError({name: ['company', OPKey.COMPANY], message});
        setCurrentStep(0);
        break;
      case userSignUpValidationMessages.DUPLICATE_TELEPHONE:
        setPendingValidationError({
          name: ['company', OPKey.TELEPHONE],
          message
        });
        setCurrentStep(0);
        break;
      case userSignUpValidationMessages.DUPLICATE_EMPLOYEE_MOBILE:
        setPendingValidationError({
          name: ['employee', EmpKey.MOBILE],
          message
        });
        setCurrentStep(2);
        break;
    }
  };

  const submitFinalStep = () => {
    form.setFieldsValue({source: steps[currentStep].id});
    const year = yearSelect(form.getFieldValue('company.fiscalYear'))?.[0]
      ?.value;
    form.setFieldValue(['facilities', yearKeyLabel.key], year);
    form
      .validateFields()
      .then(() => {
        form.submit();
      })
      .catch(() => {});
  };

  return (
    <Modal
      open={visible}
      footer={null}
      closable={true}
      maskClosable={false}
      destroyOnClose
      width={820}
      style={
        steps[currentStep].id === wizardIds.AWESOME ||
        steps[currentStep].id === wizardIds.WELCOME
          ? {height: 500}
          : {minHeight: 750}
      }
      className="onboarding-Steps-modal"
      onCancel={() => {
        setVisible(false);
      }}
      zIndex={drawerZIndex}
    >
      {isLoading ? (
        <div style={{minHeight: 530, display: 'flex', alignItems: 'center'}}>
          <Loader />{' '}
        </div>
      ) : (
        <div>
          <div>
            <Image src={steps[currentStep].image} preview={false} />
          </div>
          {currentStep !== 0 && (
            <div
              className="setupWizard"
              style={{
                width: '100%',
                background: '#f0f0f0',
                height: 24,
                marginTop: '-4.5px'
              }}
            >
              <Progress
                percent={(currentStep / (steps.length - 1)) * 100}
                showInfo={false}
                strokeColor="#3D9A50"
                strokeWidth={15}
              />
            </div>
          )}
          <div ref={targetRef} className="slide-content">
            <Form
              style={
                steps[currentStep].id === wizardIds.AWESOME ||
                steps[currentStep].id === wizardIds.WELCOME
                  ? {overflow: 'hidden', minHeight: 200}
                  : {overflow: 'hidden', minHeight: 420}
              }
              layout="vertical"
              onFinish={onSubmit}
              initialValues={formInitialValues}
              form={form}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                }
              }}
              scrollToFirstError
              autoComplete="off"
            >
              {isLast !== currentStep && currentStep !== 0 && (
                <>
                  <h2 style={{fontSize: 30}}>{steps[currentStep].title}</h2>
                </>
              )}

              {steps[currentStep].component}
              <Form.Item name="source" noStyle>
                <Input type="hidden" />
              </Form.Item>
            </Form>
            {!isLoading && currentStep !== 0 && (
              <footer style={{marginBottom: '-15px'}}>
                <div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'end',
                      justifyContent: `${
                        currentStep === 0 ? 'end' : 'space-between'
                      }`
                    }}
                  >
                    {currentStep > 0 && currentStep < isLast && (
                      <Button
                        style={{backgroundColor: '#e6ecf0', height: 40}}
                        onClick={() => {
                          goBack();
                        }}
                        disabled={isSubmitted}
                      >
                        Go Back
                      </Button>
                    )}
                    {currentStep < isLast && (
                      <div>
                        {steps[currentStep].id === wizardIds.SUSTAINABILITY && (
                          <Button
                            style={{
                              backgroundColor: '#e6ecf0',
                              height: 40,
                              marginRight: 10
                            }}
                            onClick={() => {
                              goNext();
                            }}
                            disabled={isSubmitted}
                          >
                            Skip
                          </Button>
                        )}
                        <Button
                          type="primary"
                          style={{height: 40}}
                          className="drawerButton confirmSave"
                          onClick={() => {
                            submitFinalStep();
                          }}
                          loading={isSubmitted}
                        >
                          {currentStep === isLast - 1
                            ? 'Finish'
                            : 'Save & Continue'}
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </footer>
            )}
          </div>
        </div>
      )}
    </Modal>
  );
};

export default GuestCompanySetUpWizard;
